var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a2a_kit a2a_kit_size_24 a2a_default_style"},_vm._l((_vm.buttons),function(btn){return _c('a',{key:btn.value,class:("a2a_button_" + (btn.value)),attrs:{"title":btn.label}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }